<headerCustom></headerCustom>
<sidebarWrapper></sidebarWrapper>

<!--Add User Modal Box-->
<div
  *ngIf="showHideModel"
  data-backdrop="static"
  class="modal fade"
  id="adduserPopContainer"
  tabindex="-1"
  role="dialog"
  aria-labelledby="adduserPopContainer"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <form [formGroup]="addUserForm" *ngIf="skillData && skillData.length > 0">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">TR Nominee Detail Form</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Emp Code</label
                >
                <div>
                  <input
                    type="text"
                    [ngClass]="{ 'is-invalid': submitted && f.empCode.errors }"
                    placeholder="Enter Employee Code"
                    class="form-control"
                    [(ngModel)]="empCode"
                    formControlName="empCode"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="resourceName" class="col-form-label control-label"
                  >Emp Name</label
                >
                <div>
                  <input
                    type="text"
                    [ngClass]="{
                      'is-invalid': submitted && f.resourceName.errors
                    }"
                    placeholder="Enter Employee Name"
                    class="form-control"
                    [(ngModel)]="resourceName"
                    formControlName="resourceName"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="resourceEmail" class="col-form-label control-label"
                  >Email id</label
                >
                <div>
                  <input
                    type="text"
                    [ngClass]="{
                      'is-invalid': submitted && f.resourceEmail.errors
                    }"
                    placeholder="Enter Email id"
                    class="form-control"
                    [(ngModel)]="resourceEmail"
                    formControlName="resourceEmail"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label
                  for="resourceManager"
                  class="col-form-label control-label"
                  >Supervisor Name</label
                >
                <div>
                  <input
                    type="text"
                    [ngClass]="{
                      'is-invalid': submitted && f.resourceManager.errors
                    }"
                    placeholder="Enter Supervisor Name"
                    class="form-control"
                    [(ngModel)]="resourceManager"
                    formControlName="resourceManager"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="empStatus" class="col-form-label control-label"
                  >Employee Status</label
                >
                <div>
                  <select
                    class="form-control"
                    placeholder="Employee Status"
                    formControlName="empStatus"
                  >
                    <ng-container
                      *ngFor="let empstatus of empStatusList; let i = index"
                    >
                      <option value="{{ empstatus.value }}">
                        {{ empstatus.key }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="batchNo" class="col-form-label">Batch Number</label>
                <div>
                  <select
                    class="form-control"
                    placeholder="Employee Status"
                    formControlName="batchNo"
                  >
                    <option value="">Select</option>
                    <ng-container
                      *ngFor="let batch of batchNoList; let i = index"
                    >
                      <option value="{{ batch }}">{{ batch }}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="empStatus" class="col-form-label"
                  >Journey Completion Date</label
                >
                <div>
                  <div class="input-group">
                    <input
                      autocomplete="off"
                      [ngClass]="{
                        'is-invalid':
                          submitted && f.journeyCompletionDate.errors
                      }"
                      placeholder="yyyy-mm-dd"
                      ngbDatepicker
                      #d3="ngbDatepicker"
                      [(ngModel)]="journeyCompletionDate"
                      formControlName="journeyCompletionDate"
                      class="form-control"
                      readonly
                    />
                    <div class="input-group-append">
                      <button
                        class="btn hvr-bounce-to-top"
                        (click)="d3.toggle()"
                        type="button"
                      >
                        <img src="assets/calendar-icon.svg" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="isApproved" class="col-form-label">Status</label>
                <div>
                  <select
                    class="form-control"
                    placeholder="TR Status"
                    formControlName="isApproved"
                    [attr.disabled]="curStatus == 2 ? '' : null"
                  >
                    <ng-container
                      *ngFor="let trstatus of trStatusList; let i = index"
                    >
                      <option value="{{ trstatus.value }}">
                        {{ trstatus.key }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label
                  for="resourceManagerEmail"
                  class="col-form-label control-label"
                  >Supervisor Email</label
                >
                <div>
                  <input
                    type="text"
                    [ngClass]="{
                      'is-invalid': submitted && f.resourceManagerEmail.errors
                    }"
                    placeholder="Enter Supervisor Email"
                    class="form-control"
                    [(ngModel)]="resourceManagerEmail"
                    formControlName="resourceManagerEmail"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="SUPCode" class="col-form-label control-label"
                  >SUP code</label
                >
                <div>
                  <input
                    type="text"
                    [ngClass]="{ 'is-invalid': submitted && f.SUPCode.errors }"
                    placeholder="Enter SUP Code"
                    class="form-control"
                    [(ngModel)]="SUPCode"
                    formControlName="SUPCode"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="SLS" class="col-form-label control-label"
                  >Second Level Supervisor Name</label
                >
                <div>
                  <input
                    type="text"
                    [ngClass]="{ 'is-invalid': submitted && f.SLS.errors }"
                    placeholder="Enter Second Level Supervisor"
                    class="form-control"
                    [(ngModel)]="SLS"
                    formControlName="SLS"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="SLSE" class="col-form-label control-label"
                  >Second Level Supervisor Email</label
                >
                <div>
                  <input
                    type="text"
                    [ngClass]="{ 'is-invalid': submitted && f.SLSE.errors }"
                    placeholder="Enter Second Level Supervisor Email"
                    class="form-control"
                    [(ngModel)]="SLSE"
                    formControlName="SLSE"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="SLSUPCode" class="col-form-label control-label"
                  >Second Level Supervisor code</label
                >
                <div>
                  <input
                    type="text"
                    [ngClass]="{
                      'is-invalid': submitted && f.SLSUPCode.errors
                    }"
                    placeholder="Enter Second Level SUP Code"
                    class="form-control"
                    [(ngModel)]="SLSUPCode"
                    formControlName="SLSUPCode"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="SLST" class="col-form-label control-label"
                  >Total Trainings Attended</label
                >
                <div>
                  <input
                    type="number"
                    min="0"
                    [ngClass]="{ 'is-invalid': submitted && f.TTA.errors }"
                    placeholder="Enter Total Traininigs Attended"
                    class="form-control"
                    [(ngModel)]="TTA"
                    formControlName="TTA"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label
                  for="currentPosition"
                  class="col-form-label control-label"
                  >Current Role</label
                >
                <div>
                  <select
                    class="form-control"
                    (change)="roleCheck()"
                    id="form-current-role"
                    [(ngModel)]="currentPosition"
                    placeholder="Select Position"
                    formControlName="currentPosition"
                  >
                    <option value="">Select Position</option>
                    <ng-container
                      *ngFor="
                        let position of currentPositionList;
                        let i = index
                      "
                    >
                      <option value="{{ position.positionId }}">
                        {{ position.positionName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="nextPosition" class="col-form-label control-label"
                  >Next Role</label
                >
                <div>
                  <select
                    class="form-control"
                    (change)="roleCheck()"
                    [(ngModel)]="nextPosition"
                    id="form-next-role"
                    placeholder="Select Position"
                    formControlName="nextPosition"
                  >
                    <option value="">Select Position</option>
                    <ng-container
                      *ngFor="let position of nextPositionList; let i = index"
                    >
                      <option value="{{ position.positionId }}">
                        {{ position.positionName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4" [class]="isNextTowerSame ? 'd-none' : ''">
              <div class="form-group">
                <label for="ascasc" class="col-form-label control-label"
                  >Next IBU</label
                >
                <div>
                  <select
                    id="form-ibu"
                    class="form-control"
                    (change)="onChangeIBU($event)"
                  >
                    <option value="">Select IBU</option>
                    <ng-container *ngFor="let ibuItem of ibuList">
                      <option value="{{ ibuItem.ibuId }}">
                        {{ ibuItem.ibuName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-4" [class]="isNextTowerSame ? 'd-none' : ''">
              <div class="form-group">
                <label for="fwefwef" class="col-form-label control-label"
                  >Next Function</label
                >
                <div>
                  <select
                    class="form-control"
                    id="form-function"
                    (change)="onChangeFunction($event)"
                  >
                    <option value="">Select Function</option>
                    <ng-container *ngFor="let functionItem of functionList">
                      <option value="{{ functionItem.functionId }}">
                        {{ functionItem.functionName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-4" [class]="isNextTowerSame ? 'd-none' : ''">
              <div class="form-group">
                <label for="wfefwef" class="col-form-label control-label"
                  >Next Tower</label
                >
                <div>
                  <select
                    class="form-control"
                    id="form-tower"
                    (change)="onChangeTower($event)"
                  >
                    <option value="">Select Tower</option>
                    <ng-container *ngFor="let towerItem of towerList">
                      <option value="{{ towerItem.towerId }}">
                        {{ towerItem.towerName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="joinDate" class="col-form-label control-label"
                  >Date Of Joining</label
                >
                <div>
                  <div class="input-group">
                    <input
                      autocomplete="off"
                      [ngClass]="{
                        'is-invalid': submitted && f.joinDate.errors
                      }"
                      placeholder="yyyy-mm-dd"
                      ngbDatepicker
                      #d1="ngbDatepicker"
                      [(ngModel)]="joinDate"
                      formControlName="joinDate"
                      class="form-control"
                      readonly
                    />
                    <div class="input-group-append">
                      <button
                        class="btn hvr-bounce-to-top"
                        (click)="d1.toggle()"
                        type="button"
                      >
                        <img src="assets/calendar-icon.svg" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="leaveDate" class="col-form-label"
                  >Date Of Leaving</label
                >
                <div>
                  <div class="input-group">
                    <input
                      class="form-control"
                      type="text"
                      [(ngModel)]="leaveDate"
                      autocomplete="off"
                      placeholder="yyyy-mm-dd"
                      ngbDatepicker
                      #d2="ngbDatepicker"
                      formControlName="leaveDate"
                      readonly
                    />
                    <div class="input-group-append">
                      <button
                        class="btn hvr-bounce-to-top"
                        (click)="d2.toggle()"
                        type="button"
                      >
                        <img src="assets/calendar-icon.svg" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            *ngIf="userUpdatedId > 0"
            class="btn hvr-bounce-to-top"
            title="Update"
            (click)="onUpdateSubmit(addUserForm.value)"
            [disabled]="addUserForm.invalid"
          >
            Save
          </button>
          <button
            *ngIf="userUpdatedId == 0"
            class="btn hvr-bounce-to-top"
            (click)="onSubmit(addUserForm.value)"
            [disabled]="addUserForm.invalid"
          >
            Add TR Nominee
          </button>
          <button
            type="button"
            class="btn hvr-bounce-to-top"
            data-dismiss="modal"
            aria-label="Close"
            #closeModel
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- For Add Notes -->
<div
  style="font-family: 'Roboto'"
  class="modal fade"
  id="addNotesPopContainer"
  tabindex="-1"
  role="dialog"
  aria-labelledby="addNotesPopContainer"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <form [formGroup]="userNotesForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Notes</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="userNotes" class="col-form-label control-label"
                  >Remark</label
                >
                <div>
                  <textarea
                    placeholder="Enter User Notes"
                    class="form-control"
                    formControlName="userNotes"
                    rows="4"
                  >
                  </textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- <button type="button"  class="btn btn-info btn-sm" (click)="addNewNotes()" >Add Notes</button> -->

          <button
            class="btn hvr-bounce-to-top"
            (click)="onSubmitUserNotes(userNotesForm.value)"
          >
            Add Remark
          </button>
          <button
            type="button"
            class="btn hvr-bounce-to-top"
            data-dismiss="modal"
            aria-label="Close"
            id="addNotesPopContainer"
          >
            Cancel
          </button>
        </div>
        <div class="addUserButtonTableData">
          <div
            class="addUserFormLayout customizeRtsScrollBar addUserFormContainer"
          >
            <table class="table rTsCustomizeTable">
              <thead>
                <tr>
                  <th style="font-weight: 200 !important">S.No.</th>
                  <th style="font-weight: 200 !important" width="400px">
                    From
                  </th>
                  <th style="font-weight: 200 !important" width="400px">
                    Remark
                  </th>
                  <!-- <th style="font-weight: 200 !important">Action</th> -->
                  <th style="font-weight: 200 !important" width="400px">
                    Create Date
                  </th>
                </tr>
              </thead>
              <tbody class="text-center" style="font-family: 'Roboto'">
                <ng-container
                  *ngFor="let notes of userNotesList; let i = index"
                >
                  <tr>
                    <td>
                      {{ i + 1 }}
                    </td>
                    <td class="employeeCode">
                      <div>{{ notes?.noteUserName }}</div>
                    </td>
                    <td class="employeeCode">
                      <div>{{ notes?.userNotes }}</div>
                    </td>

                    <td class="addUserButtons">
                      <div>
                        {{ notes?.createDate | date : "yyyy-M-dd h:mm a" }}
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr *ngIf="userNotesList.length < 1">
                  <td colspan="3">No Results Found.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!--Email confirmation Box-->
<div
  *ngIf="showHideModel"
  class="modal fade"
  id="sendIndiMail"
  tabindex="-1"
  role="dialog"
  aria-labelledby="sendIndiMail"
  aria-hidden="true"
  data-keyboard="false"
  data-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Email Confirmation</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 cusPad20">
            Are you sure you want to send the mail?
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn hvr-bounce-to-top"
          title="Cancel"
          data-dismiss="modal"
          aria-label="Close"
        >
          Cancel
        </button>
        <button
          class="btn hvr-bounce-to-top"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onEmailClick()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>

<!-- All Email confirmation Box-->
<div
  *ngIf="showHideModel"
  class="modal fade"
  id="sendAllMail"
  tabindex="-1"
  role="dialog"
  aria-labelledby="sendAllMail"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Email Confirmation</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            Are you sure you want to send the emails to all?
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn hvr-bounce-to-top"
          title="Cancel"
          data-dismiss="modal"
          aria-label="Close"
        >
          Cancel
        </button>
        <button
          class="btn hvr-bounce-to-top"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onAllEmailClick()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ReNomination confirmation Box -->
<div
  *ngIf="showHideModel"
  class="modal fade"
  id="reNominate"
  tabindex="-1"
  role="dialog"
  aria-labelledby="reNominate"
  aria-hidden="true"
  data-keyboard="false"
  data-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Re-Nomination Confirmation</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 cusPad20">
            Are you sure you want to re-nominate this user?
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn hvr-bounce-to-top"
          title="Cancel"
          data-dismiss="modal"
          aria-label="Close"
        >
          Cancel
        </button>
        <button
          class="btn hvr-bounce-to-top"
          data-dismiss="modal"
          aria-label="Close"
          (click)="resetForReNominate()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Show user History Table -->
<div
  *ngIf="showHideModel"
  class="modal fade"
  id="userHistory"
  tabindex="-1"
  role="dialog"
  aria-labelledby="userHistory"
  aria-hidden="true"
  data-keyboard="false"
  data-backdrop="static"
>
  <div
    class="modal-dialog modal-dialog-centered"
    role="document"
    style="max-width: 1150px"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Nominated User History</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="addUserButtonTableData">
          <div
            class="addUserFormLayout customizeRtsScrollBar addUserFormContainer"
          >
            <table class="table rTsCustomizeTable">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th width="10%">Emp Code</th>
                  <th>Emp Name</th>
                  <th>Email id</th>
                  <th>Current Role</th>
                  <th>Target Role</th>
                  <th>Status</th>
                  <th>Nominated At</th>
                  <!-- <th>Action</th> -->
                </tr>
              </thead>
              <tbody class="text-center">
                <ng-container
                  *ngFor="let userHistory of nominatedUseristory; let i = index"
                >
                  <tr>
                    <td>
                      <div>
                        {{ nominatedUseristory.indexOf(userHistory) + 1 }}
                      </div>
                    </td>
                    <td class="employeeCode">
                      <div>{{ userHistory.empCode }}</div>
                    </td>

                    <td class="addUserName">
                      <div>{{ userHistory.userName }}</div>
                    </td>
                    <td class="addUserName">
                      <div>{{ userHistory.email }}</div>
                    </td>
                    <td class="userSelectType">
                      <div>
                        {{ getPositionName(userHistory.currentPosition) }}
                      </div>
                    </td>
                    <td>
                      <div>{{ getPositionName(userHistory.nextPosition) }}</div>
                    </td>
                    <td>
                      <div
                        #statusId
                        [ngStyle]="{
                          color:
                            userHistory.isApproved == 3
                              ? 'red'
                              : userHistory.isApproved == 1
                              ? 'green'
                              : userHistory.isApproved == 0
                              ? 'red'
                              : 'black'
                        }"
                      >
                        {{
                          commonService.getUserStatus(userHistory.isApproved)
                        }}
                      </div>
                    </td>
                    <td>
                      <div>
                        {{
                          userHistory.approvedAt ? userHistory.approvedAt : "NA"
                        }}
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr *ngIf="nominatedUseristory?.length < 1">
                  <td class="addUserName text-center" colspan="8">
                    User History Not Found!
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- User Import-->
<div
  *ngIf="showHideModel"
  data-backdrop="static"
  class="modal fade"
  id="userImportContainer"
  tabindex="-1"
  role="dialog"
  aria-labelledby="userImportContainer"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form [formGroup]="importUserForm" class="width100">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Import Nominee Data</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="userFile" class="col-form-label control-label"
                  >Choose File</label
                >
                <div>
                  <input
                    type="file"
                    formControlName="userFile"
                    id="userFile"
                    (change)="onFileSelect($event)"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <a href="assets/sample_template.xlsx" target="_blank"
                >Sample template</a
              >
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn hvr-bounce-to-top"
            (click)="onUserImportSubmit(importUserForm.value)"
            [disabled]="importUserForm.invalid"
          >
            Submit
          </button>
          <button
            type="button"
            class="btn hvr-bounce-to-top"
            data-dismiss="modal"
            aria-label="Close"
            #closeModel
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="main-content">
  <div class="adduserContainer">
    <div class="pageContentWrapper">
      <div class="pageHeading">
        <div class="row">
          <div class="col-4">
            <div class="headerName">
              <h3>TR Nominees</h3>
              <app-breadcrumb></app-breadcrumb>
            </div>
          </div>
          <div class="col-8 addUserButton text-right">
            <div class="row">
              <div class="col-12">
                <button
                  type="button"
                  *ngIf="currentRole == 3"
                  class="btn hvr-bounce-to-top"
                  data-toggle="modal"
                  data-target="#adduserPopContainer"
                  (click)="initalizeUserForm()"
                >
                  Add TR Nominee
                </button>
                <button
                  type="button"
                  class="btn hvr-bounce-to-top mr10"
                  (click)="excelReport()"
                >
                  Excel Export
                </button>
                <button
                  *ngIf="userRole == 3"
                  type="button"
                  class="btn hvr-bounce-to-top mr10"
                  data-toggle="modal"
                  data-target="#sendAllMail"
                >
                  Send Email to all
                </button>
                <button
                  type="button"
                  *ngIf="currentRole == 3"
                  class="btn hvr-bounce-to-top mr10"
                  data-toggle="modal"
                  data-target="#userImportContainer"
                  (click)="initImportUserForm()"
                >
                  Import Nominee Data
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="addUserButtonTableData" *ngIf="fetchData.length == 0">
        <div
          class="addUserFormLayout customizeRtsScrollBar addUserFormContainer"
        >
          <div class="text-right">
            <button
              #columnList
              class="btn form-group newcls"
              title="User Details"
              data-toggle="modal"
              data-target="#columnList"
            >
              <!-- <i class="fa fa-user"></i> -->
              Columns
            </button>
          </div>
          <table
            *ngIf="dtRendered"
            datatable
            [dtOptions]="dtOptions"
            class="table rTsCustomizeTable userListTab"
          >
            <thead>
              <tr>
                <th>S.No.</th>
                <ng-container
                  *ngFor="let column of selectedItems; trackBy: trackByIndex"
                >
                  <th>{{ column?.item_text }}</th>
                </ng-container>
                <th>Action</th>
              </tr>
            </thead>
            <tbody class="text-center"></tbody>
          </table>
        </div>
      </div>
      <!-- Popup for columns listing -->
      <div
        class="modal fade"
        id="columnList"
        tabindex="-1"
        role="dialog"
        aria-labelledby="columnList"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content" style="height: 400px">
            <div class="modal-header">
              <h5 class="modal-title">Column List</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <ng-multiselect-dropdown
                [placeholder]="'Add columns in table'"
                [settings]="dropdownSettings"
                [data]="columnList"
                [(ngModel)]="selectedItems"
                (onSelect)="onItemSelect($event)"
                (onDeSelect)="onUnselectColumn($event)"
                (onSelectAll)="onSelectAll($event)"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="addUserButtonTableData" *ngIf="fetchData.length > 0">
        <div
          class="addUserFormLayout customizeRtsScrollBar addUserFormContainer"
        >
          <div class="text-right">
            <button
              #columnList
              class="btn form-group newcls"
              title="User Details"
              data-toggle="modal"
              data-target="#columnList"
            >
              <!-- <i class="fa fa-user"></i> -->
              Columns
            </button>
          </div>
          <table
            *ngIf="dtRendered"
            datatable
            [dtOptions]="dtOptions"
            class="table rTsCustomizeTable userListTab"
          >
            <thead>
              <tr>
                <th>S.No.</th>
                <ng-container
                  *ngFor="let column of selectedItems; trackBy: trackByIndex"
                >
                  <th>{{ column?.item_text }}</th>
                </ng-container>
                <th data-orderable="false" *ngIf="userRole != 7">Action</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <ng-container
                *ngFor="let fetchuserData of fetchData; let i = index"
              >
                <tr>
                  <td>
                    <div ngClass="{{ fetchuserData.leaveUserCSS }}">
                      {{ fetchData.indexOf(fetchuserData) + 1 }}
                    </div>
                  </td>
                  <ng-container *ngFor="let column of selectedItems">
                    <td>
                      <div
                        ngClass=""
                        [ngStyle]="{
                          color:
                            fetchuserData['empStatus'] == 1 ? 'black' : 'red'
                        }"
                        *ngIf="
                          column.slug == 'currentPosition' ||
                          column.slug == 'nextPosition'
                        "
                      >
                        {{ getPositionName(fetchuserData[column.slug]) }}
                      </div>
                      <div
                        ngClass=""
                        [ngStyle]="{
                          color:
                            fetchuserData['empStatus'] == 1 ? 'black' : 'red'
                        }"
                        *ngIf="column.slug == 'empStatus'"
                      >
                        {{ getEmpStatus(fetchuserData[column.slug]) }}
                      </div>
                      <div
                        ngClass=""
                        [ngStyle]="{
                          color:
                            fetchuserData['empStatus'] == 1 ? 'black' : 'red'
                        }"
                        *ngIf="column.slug == 'journeyCompletionDate'"
                      >
                        {{ fetchuserData[column.slug] | date : "yyyy-MM-dd" }}
                      </div>
                      <div
                        ngClass=""
                        *ngIf="
                          column.slug == 'isApproved' &&
                          fetchuserData['empStatus'] == 1
                        "
                        [ngStyle]="{
                          color:
                            apprArry[i] == 0
                              ? 'red'
                              : apprArry[i] == 1
                              ? 'green'
                              : apprArry[i] == 3
                              ? 'red'
                              : 'black'
                        }"
                      >
                        {{ commonService.getUserStatus(apprArry[i]) }}
                      </div>
                      <div
                        ngClass=""
                        *ngIf="
                          column.slug == 'isApproved' &&
                          fetchuserData['empStatus'] != 1
                        "
                        [ngStyle]="{
                          color:
                            fetchuserData['empStatus'] == 1 ? 'black' : 'red'
                        }"
                      >
                        {{ commonService.getUserStatus(apprArry[i]) }}
                      </div>
                      <div
                        ngClass=""
                        [ngStyle]="{
                          color:
                            fetchuserData['empStatus'] == 1 ? 'black' : 'red'
                        }"
                        *ngIf="column.slug == 'userId'"
                      >
                        {{ returnUserNotes(fetchuserData.userId) }}
                      </div>
                      <div
                        ngClass=""
                        [ngStyle]="{
                          color:
                            fetchuserData['empStatus'] == 1 ? 'black' : 'red'
                        }"
                        *ngIf="
                          column.slug != 'currentPosition' &&
                          column.slug != 'nextPosition' &&
                          column.slug != 'empStatus' &&
                          column.slug != 'journeyCompletionDate' &&
                          column.slug != 'isApproved' &&
                          column.slug != 'userId'
                        "
                      >
                        {{ fetchuserData[column.slug] }}
                      </div>
                    </td>
                  </ng-container>
                  <td class="addUserButtons" *ngIf="userRole != 7">
                    <div>
                      <button
                        class="btn form-group hvr-bounce-to-top"
                        title="Edit"
                        data-toggle="modal"
                        data-target="#adduserPopContainer"
                        (click)="onEditSubmit(fetchuserData)"
                      >
                        <img src="assets/edit.svg" />
                        <!-- <i class="far fa-edit"></i> -->
                      </button>
                      <button
                        #btnMailId
                        *ngIf="userRole == 3"
                        class="btn form-group hvr-bounce-to-top newcls"
                        title="Send Email"
                        data-toggle="modal"
                        data-target="#sendIndiMail"
                        (click)="
                          onEmailClickData(
                            fetchuserData.email,
                            fetchuserData.resourceManagerEmail,
                            fetchuserData.userId
                          )
                        "
                        [disabled]="
                          apprArry[i] == 0
                            ? true
                            : apprArry[i] == 1
                            ? false
                            : true
                        "
                      >
                        <i class="fa fa-envelope"></i>
                      </button>
                      <!-- Only for HR login  -->
                      <button
                        #btnRenominate
                        *ngIf="
                          (fetchuserData.isApproved == 4 ||
                            fetchuserData.isApproved == 5 ||
                            fetchuserData.isApproved == 6) &&
                          userRole == 3 &&
                          fetchuserData.mFunRatings == 1 &&
                          fetchuserData.mBehRatings == 1
                        "
                        class="btn form-group hvr-bounce-to-top newcls"
                        title="Reset for Re-Nominate"
                        data-toggle="modal"
                        data-target="#reNominate"
                        (click)="
                          onResetUserforReNomination(
                            fetchuserData.userId,
                            fetchuserData
                          )
                        "
                      >
                        <i class="fa fa-refresh"></i>
                      </button>
                      <!-- Only for HR login  -->
                      <button
                        #btnUserHistory
                        *ngIf="userRole == 3"
                        class="btn form-group hvr-bounce-to-top newcls"
                        title="User History"
                        data-toggle="modal"
                        data-target="#userHistory"
                        (click)="onUserHistory(fetchuserData)"
                      >
                        <i class="fa fa-history"></i>
                      </button>
                      <button
                        class="btn form-group hvr-bounce-to-top"
                        title="User Notes"
                        data-toggle="modal"
                        data-target="#addNotesPopContainer"
                        (click)="onEditUserNotes(fetchuserData)"
                      >
                        <i class="fa fa-sticky-note" aria-hidden="true"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="loader" *ngIf="loading">
  <div class="lds-roller">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
